"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosTenantDomainSchema = exports.APosTenantDomainStatusSchema = exports.APosTenantDomainTypeSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
exports.APosTenantDomainTypeSchema = zod_1.z.enum(['subdomain', 'custom']);
// status doubles as the billing kill switch (UNIFIED-MODEL §6.2).
exports.APosTenantDomainStatusSchema = zod_1.z.enum(['active', 'suspended', 'pending']);
exports.APosTenantDomainSchema = zod_1.z.object({
    hostname: zod_1.z.string().min(1).describe('lowercase host, PK'),
    tenantId: id_schema_1.TenantIdSchema,
    type: exports.APosTenantDomainTypeSchema,
    sslStatus: zod_1.z.enum(['pending', 'active', 'failed']).default('pending'),
    status: exports.APosTenantDomainStatusSchema.default('active'),
    certArn: zod_1.z.string().optional(),
    distributionId: zod_1.z.string().optional(),
    // GSI SK — numeric flag (1 primary, 0 secondary) to match the table key type.
    isPrimary: zod_1.z.number().int().min(0).max(1).default(0),
    marketplaceId: zod_1.z.string().optional(),
}).merge(timestamps_schema_1.TimestampsSchema);
//# sourceMappingURL=tenant-domain.schema.js.map